function ABDOUtil() {
    
}

(function($){
    // iOSやアンドロイドのデバイスには
    // https://stackoverflow.com/questions/18201361/how-to-replace-click-with-touchstart-on-ios-devices
    $.hasTouchScreen = 'ontouchend' in document.documentElement;
    $.clickHandler =  $.hasTouchScreen ? "touchend" : "click";
    $.supportsAnimation = typeof(window.onanimationend) !== 'undefined';
    $.isDebugging = document.URL.split('/').pop()[0] == "_";
    $.isIE = typeof(document.documentMode) !== 'undefined';  
    $.getClickHandler = function(element) {
        var touchstart_tags = ['A', 'IMG'];

        var tag_in_touchstart_tags = touchstart_tags.indexOf(element.tagName) !== -1;
        if (tag_in_touchstart_tags && $.hasTouchScreen) {
            if(typeof(document.ontouchend) !== 'undefined') {
                return 'touchend';
            }
            else {
                return 'touchstart';
            }
        }

        var click_tags = ['BUTTON'];
        var tag_in_click_tags = click_tags.indexOf(element.tagName) !== -1;
        if (tag_in_click_tags) {
            return 'click';
        }
        
        return $.clickHandler;
    };

    $.getJSON = function(url, success) {
        var request = new XMLHttpRequest();
        request.addEventListener('load', function(evt) {
            if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
                var json = JSON.parse(request.responseText);
                success(json);
            }
        });
        request.open('GET', url);
        request.send();
    };

    $.loadHTML = function(url) {
        var request = new XMLHttpRequest();
        request.addEventListener('load', function(evt) {
            if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
                var div = document.createElement('div');
                div.innerHTML = request.responseText;
                for ( ; div.children.length > 0; ) {
                    var child_element = div.children[div.children.length - 1];
                    document.body.appendChild(child_element);
                } 
            }
        });
        request.open('GET', url);
        request.send();
    };

    $.clone = function(obj, deep) {
        if (typeof(deep) === 'undefined') {
            deep = false;
        }

        if (obj == null) {
            return null;
        }

        if (Array.isArray(obj)) {
            var cloned_arr = [];
            obj.forEach(function(element){
                if (deep) {
                    element = $.clone(element, deep);
                }
                cloned_arr.push(element);
            });
            return cloned_arr;
        }

        if (typeof(obj) == 'string') {
            return obj.repeat(1);
        }

        var newobj = {};
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (deep && obj[property] != null && typeof(obj[property]) === 'object') {
                    newobj[property] = $.clone(obj[property], deep);
                }
                else { 
                    newobj[property] = obj[property];
                } 
            }
        }

        return newobj;
    };

    $.datasetHasAttributes = function(dataset, attributes)  { 
        for (var att_index = 0; att_index < attributes.length; att_index++) {
            var attribute = attributes[att_index];
            if (!(attribute in dataset)) {
                return false;
            }
        }
        return true;
    };

    $.getRectFromDataset = function(element) {
        var rect_attributes = ["fromX", "fromY", "toX", "toY"];
        var rect_attributes_alternative = ["fromX", "fromY", "width", "height"];

        var fromX, fromY, toX, toY, width, height;

        if ($.datasetHasAttributes(element.dataset, rect_attributes)) {
            fromX  = parseFloat(element.dataset.fromX);
            fromY  = parseFloat(element.dataset.fromY);
            toX    = parseFloat(element.dataset.toX);
            toY    = parseFloat(element.dataset.toY);
            width  = parseFloat(toX - fromX);
            height = parseFloat(toY - fromY);
            
            return new OpenSeadragon.Rect(fromX, fromY, width, height);
        }
        else if ($.datasetHasAttributes(element.dataset, rect_attributes_alternative)) {
            fromX  = parseFloat(element.dataset.fromX);
            fromY  = parseFloat(element.dataset.fromY); 
            width  = parseFloat(element.dataset.width);
            height = parseFloat(element.dataset.height);
            
            return new OpenSeadragon.Rect(fromX, fromY, width, height);
        }

        return null; 
    };

    $.getPointFromDataset = function(element) {
        var point_attributes = ["x", "y"];
        if ($.datasetHasAttributes(element.dataset, point_attributes)) {
            var x = parseFloat(element.dataset.x);
            var y = parseFloat(element.dataset.y);
            return new OpenSeadragon.Point(x,y);
        }
        
        return null;
    };

    // data-xとdata-yがあればOpenSeadragon.Point
    // data-<from,to>-<x,y>のデータセットの要素があればOpenSeadragon.Rect
    $.getLocationFromDataset = function(element) { 
        var rect = $.getRectFromDataset(element);
        if (rect != null) {
            return rect;
        }

        var pt = $.getPointFromDataset(element);
        if (pt != null) {
            return pt;
        } 
    };

    $.isOSDPoint = function(object) {
        return OpenSeadragon.Point.prototype.isPrototypeOf(object);
    };

    $.isOSDRect = function(object) {
        return OpenSeadragon.Rect.prototype.isPrototypeOf(object);
    };

    $.isOverlay = function(object) {
        return OpenSeadragon.Overlay.prototype.isPrototypeOf(object);
    };

    $.getViewer = function() {
        var viewer = null;
        if ( typeof(abdo_osd) !== "undefined" && abdo_osd.viewers.length > 0) {
            viewer = abdo_osd.viewers[0];
        }
        return viewer;
    };

    $.getViewers = function() {
        return abdo_osd.viewers; 
    };

    $.preventCanvasPropagation = function(element) { 
        if (typeof(element.tracker) === 'undefined')  {
            var mouse_tracker = new OpenSeadragon.MouseTracker({
                element: element,
                clickHandler: null, // when is null, OpenSeadragon does not call event.preventDefault()
                // clickHandler: function(evt) {
                //     // preserve <a> capabilities as much as possible
                //     var target = evt.originalEvent.target;
                //     if (target.tagName === 'A') {
                //         if (target.getAttribute('target') === '_blank') {
                //             window.open(target.getAttribute('href'));
                //         } else {
                //             location.href = target.getAttribute('href');
                //         }
                //     }
                //     evt.originalEvent.stopImmediatePropagation();
                //     evt.originalEvent.stopPropagation();
                // }
            });
            element.tracker = mouse_tracker;
        }
    };

    $._removeClass = function(element, css_class) {
        if ($.isIE) {
            element.setAttribute('class', element.getAttribute('class').replace(css_class, ' '));
        }
        else {
            element.classList.remove(css_class);
        }
    };

    $._on_dom_loaded = function(callback) {
        if (document.readyState === 'complete') {
            callback();
        }
        else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    };

    $._resize_overlay = function(size, max_size){

        // max_size = 100.0 (default)
        if (typeof(max_size) !== 'number') {
            max_size = 100.0;
        }

        var xy_max = size.x;
        if (size.y > size.x) {
            xy_max = size.y;
        }

        // if max_size is larger than 100.0
        var scale = 1.0;
        
        if (xy_max > max_size) {
            scale = max_size / xy_max;
        } 
        
        size.x *= scale;
        size.y *= scale;
    }


})(ABDOUtil);
